module.exports = __webpack_public_path__ + "static/media/Twemoji12 23f0.630f5938.svg";